/**
 * All vpaid events from spec vpaid 2.0
 * */
export const AdLoaded = 'AdLoaded';
export const AdStarted = 'AdStarted';
export const AdStopped = 'AdStopped';
export const AdSkipped = 'AdSkipped';
export const AdSkippableStateChange = 'AdSkippableStateChange';
export const AdLinearChange = 'AdLinearChange';
export const AdDurationChange = 'AdDurationChange';
export const AdExpandedChange = 'AdExpandedChange';
export const AdRemainingTimeChange = 'AdRemainingTimeChange'; // (Deprecated in 2.0)
export const AdVolumeChange = 'AdVolumeChange';
export const AdImpression = 'AdImpression';
export const AdVideoStart = 'AdVideoStart';
export const AdVideoFirstQuartile = 'AdVideoFirstQuartile';
export const AdVideoMidpoint = 'AdVideoMidpoint';
export const AdVideoThirdQuartile = 'AdVideoThirdQuartile';
export const AdVideoComplete = 'AdVideoComplete';
export const AdVideoPreComplete = 'AdVideoPreComplete';
export const AdClickThru = 'AdClickThru';
export const AdInteraction = 'AdInteraction';
export const AdUserAcceptInvitation = 'AdUserAcceptInvitation';
export const AdUserMinimize = 'AdUserMinimize';
export const AdUserClose = 'AdUserClose';
export const AdPaused = 'AdPaused';
export const AdPlaying = 'AdPlaying';
export const AdLog = 'AdLog';
export const AdError = 'AdError';
// custom
export const AdMute = 'AdMute';
export const AdUnmute = 'AdUnmute';
export const AdMuteWhenStart = 'AdMuteWhenStart';
export const AdFullScreen = 'AdFullScreen';
export const AdClickToPlay = 'AdClickToPlay';
export const AdNotViewability = 'AdNotViewability';
export const AdThrowMidroll = 'AdThrowMidroll';
export const AdShowSkip = 'AdShowSkip';
export const AdPlayError = 'AdPlayError';
export const AdCanplay = 'AdCanplay';
export const ONQUALITYCHANGE = 'ONQUALITYCHANGE';
export const AdReplay = 'AdReplay';
